/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetViewPathParams = NonNullable<operations['getView']['parameters']['path']>;

export type GetViewQueryParams = NonNullable<operations['getView']['parameters']['query']>;

export interface Input extends GetViewPathParams {
  apiVersion?: string;
  query?: GetViewQueryParams;
  header: NonNullable<operations['getView']['parameters']['header']>;
}

export async function getView(
  { apiVersion, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/views/{viewKey}', {
    params: { path, query, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
